module.exports = __webpack_public_path__ + "static/media/moto.b7b4ab02.svg";